export const ReservationsList = () => {
  return <div></div>;
};
